import React from 'react';
import type { ReactElement, MouseEvent } from 'react';

import { CloseIcon } from '@/assets/icons/v2/CloseIcon';
import { StaticPlayer } from './components/Static';
import { useVideoPlayerContext } from './context';

import * as S from './styles';

function renderCloseIcon(): ReactElement {
	return (
		<S.HoverIcon>
			<CloseIcon width={10} height={13} />
		</S.HoverIcon>
	);
}

interface VideoPlayerStaticProps {
	children: JSX.Element | JSX.Element[];
	portrait?: boolean;
	onClose?: () => void;
	onClick?: (event: MouseEvent) => void;
	onMouseEnter?: (event: MouseEvent) => void;
	onMouseLeave?: (event: MouseEvent) => void;
}

export function VideoPlayerStatic({
	children,
	portrait,
	onClose,
	onClick,
	onMouseEnter,
	onMouseLeave
}: Readonly<VideoPlayerStaticProps>): ReactElement {
	const { showCloseButton, handleCloseIconClick, handleExpandClick, handleVideoMouseEnter, handleVideoMouseLeave } =
		useVideoPlayerContext();

	function handleClose(): void {
		handleCloseIconClick();
		onClose?.();
	}

	function handleClick(event: MouseEvent): void {
		handleExpandClick(event);
		onClick?.(event);
	}

	function handleMouseEnterEvent(event: MouseEvent): void {
		handleVideoMouseEnter();
		onMouseEnter?.(event);
	}

	function handleMouseLeaveEvent(event: MouseEvent): void {
		handleVideoMouseLeave();
		onMouseLeave?.(event);
	}

	return (
		<StaticPlayer
			portrait={portrait}
			closeIcon={showCloseButton ? renderCloseIcon() : undefined}
			onClose={handleClose}
			onClick={handleClick}
			onMouseEnter={handleMouseEnterEvent}
			onMouseLeave={handleMouseLeaveEvent}
		>
			{children}
		</StaticPlayer>
	);
}
